/** Shared element resolution for lazy-motion primitives. */

export const SUPPORTED_TAGS = new Set([
  "a",
  "article",
  "button",
  "div",
  "h1",
  "h2",
  "h3",
  "h4",
  "header",
  "li",
  "main",
  "nav",
  "p",
  "section",
  "span",
  "ul",
]);

export function resolveTag(as) {
  if (typeof as === "string") {
    const tag = as.toLowerCase();
    if (SUPPORTED_TAGS.has(tag)) return tag;
  }
  return "div";
}

export function getMotionComponent(motionApi, tag) {
  const component = motionApi[tag];
  return component != null ? component : motionApi.div;
}
